import React from "react";

/**
 * Klareet pill-shaped button. Solid teal primary, ghost secondary.
 * Variants: "primary" | "ghost" | "outline"
 */
export function Button({
    variant = "primary",
    size = "md",
    className = "",
    disabled,
    children,
    ...rest
}) {
    const base =
        "inline-flex items-center justify-center gap-2 font-medium tracking-tight rounded-full transition-[transform,background-color,color,box-shadow] duration-200 ease-out focus-visible:outline-none disabled:opacity-50 disabled:cursor-not-allowed select-none";
    const sizes = {
        sm: "px-4 py-2 text-sm",
        md: "px-6 py-3 text-[15px]",
        lg: "px-8 py-4 text-base",
    };
    const variants = {
        primary:
            "bg-klareet-T text-klareet-TEXT hover:bg-klareet-T2 hover:-translate-y-0.5 shadow-[0_8px_30px_-10px_rgba(13,148,136,0.6)]",
        ghost:
            "bg-transparent text-klareet-TEXT hover:bg-white/5",
        outline:
            "bg-transparent text-klareet-TEXT border border-klareet-BOR hover:border-klareet-T hover:bg-white/5",
    };
    return (
        <button
            type="button"
            className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
}
